import { AuthToken } from '../features/auth';
import { LocalStorageKeys } from './enums';

class LocalStorageService {
  public static setToken(token: AuthToken) {
    localStorage.setItem(LocalStorageKeys.TOKEN, JSON.stringify(token));
  }

  public static getToken(): AuthToken | null {
    const stringToken = localStorage.getItem(LocalStorageKeys.TOKEN);

    if (stringToken) {
      return JSON.parse(stringToken);
    }
    return null;
  }

  public static clearToken() {
    localStorage.removeItem(LocalStorageKeys.TOKEN);
  }

  public static setReferrer(ref: string) {
    localStorage.setItem(LocalStorageKeys.REFERRER, ref);
  }

  public static getReferrer(): string | null {
    return localStorage.getItem(LocalStorageKeys.REFERRER);
  }

  public static clearReferrer() {
    return localStorage.removeItem(LocalStorageKeys.REFERRER);
  }
}

export { LocalStorageService };
